<svg
      [attr.width]="width"
      [attr.height]="circleHeight"
      [attr.viewBox]="'0 0 ' + (width) + ' ' + height"
    >
      <!-- Arc de fond -->
      <path
        [attr.d]="arcPath"
        fill="transparent"
        [attr.stroke-width]="stroke"
        stroke="#e6e6e6"
      ></path>

      <!-- Arc de progression -->
      <path
        [attr.d]="arcPath"
        fill="transparent"
        [attr.stroke-width]="stroke"
        [attr.stroke]="color"
        stroke-linecap="round"
        [attr.stroke-dasharray]="circumference"
        [attr.stroke-dashoffset]="strokeDashoffset"
        class="progress-arc"
      ></path>

      <!-- Texte centré -->
      <text
        *ngIf="displayMode === enProgressDisplayText.ValueAndMax && max !=0"
        [attr.x]="width / 2"
        [attr.y]="circleHeight - 10"
        text-anchor="middle"
        font-size="14"
        [attr.fill]="color"
      >
        {{ (value || 0) | number:'1.0-0' }} / {{max}}
      </text>
      <text
        *ngIf="displayMode === enProgressDisplayText.Percent"
        [attr.x]="width / 2"
        [attr.y]="circleHeight - 10"
        text-anchor="middle"
        font-size="14"
        [attr.fill]="color"
      >
        {{ (percent) | number:'1.0-0' }}%
      </text>
      <text
        *ngIf="displayMode === enProgressDisplayText.ValueOnly"
        [attr.x]="width / 2"
        [attr.y]="circleHeight - 10"
        text-anchor="middle"
        font-size="14"
        [attr.fill]="color"
      >
        {{ (value || 0) | number:'1.0-0' }}
      </text>
    </svg>